import { useState, useEffect } from "react";

const API = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

let globalExperiences = null;
let globalExperiencesPromise = null;

/**
 * Fetch all experiences from the backend.
 * Returns: { experiences, loading, error }
 * experiences = array sesuai model Experience.js
 */
export const useExperiences = () => {
  const [experiences, setExperiences] = useState(globalExperiences || []);
  const [loading, setLoading]         = useState(globalExperiences === null);
  const [error, setError]             = useState(null);

  useEffect(() => {
    let cancelled = false;

    if (globalExperiences !== null) {
      setExperiences(globalExperiences);
      setLoading(false);
      window.__experiencesLoaded = true;
      return;
    }

    if (!globalExperiencesPromise) {
      window.__experiencesLoaded = false;
      globalExperiencesPromise = fetch(`${API}/api/experiences`)
        .then((r) => {
          if (!r.ok) throw new Error("Failed to fetch experiences");
          return r.json();
        })
        .then((json) => {
          globalExperiences = json.data || [];
          window.__experiencesLoaded = true;
          return globalExperiences;
        })
        .catch((err) => {
          window.__experiencesLoaded = true;
          throw err;
        });
    }

    globalExperiencesPromise
      .then((data) => {
        if (!cancelled) {
          setExperiences(data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message);
          setLoading(false);
        }
      });

    return () => { cancelled = true; };
  }, []);

  // Helper: ambil experience berdasarkan id
  const getExp = (id) => experiences.find((e) => e.id === id);

  return { experiences, loading, error, getExp };
};
